import { createSelector } from 'reselect';

import getShop from '@core/reducers/shop/selectors/getShop';
import { getCountryVerticals, getRouterState } from '@shared/selectors';
import getSectionsList from '@shopDetails/selectors/getSectionsList';
import getSectionsListTotal from '@shopDetails/selectors/getSectionsListTotal';
import getSectionsListCount from '@shopDetails/selectors/getSectionsListCount';
import getStopFetchingSections from '@shopDetails/selectors/getStopFetchingSections';
import getGlobalDiscountsWeekly from '@core/reducers/menu/selectors/getGlobalDiscountsWeekly';

export const getSectionListLoadStatus = createSelector(
  getSectionsList,
  getSectionsListTotal,
  getSectionsListCount,
  getStopFetchingSections,
  (sectionList, total, count, stopFetching) => ({
    count: sectionList?.length,
    hasMore: !stopFetching && count < total, // stopFetching WHILE BUG IN SERVER
  }),
);

export const getShopBusinessType = createSelector(
  getShop,
  shop => shop?.businessType,
);

export const getShopDiscount = createSelector(
  getGlobalDiscountsWeekly,
  weeklyDiscount => weeklyDiscount?.amount,
);

export const getRedirectToShopDetails = createSelector(getRouterState, state =>
  Boolean(state?.redirect),
);

export const getVerticalForSelectedShop = createSelector(
  getCountryVerticals,
  getShopBusinessType,
  (verticals, businessType) => {
    const vertical = verticals.find(x => x.businessType === businessType);
    return vertical || {};
  },
);
